var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-field',[_vm._t("default"),_c('md-input',{attrs:{"value":_vm.value,"type":"text"},on:{"change":function($event){return _vm.updateValue($event)}}}),_c('input',{attrs:{"type":"color"},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.updateValue($event)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }